import { createReducer, on } from '@ngrx/store';
import { assistantSubscriptionActions } from './subscription.actions';
import { assistantSubscriptionState } from './subscription.state';

export const assistantSubscriptionReducer = createReducer(
  assistantSubscriptionState,
  on(assistantSubscriptionActions.check360ReportStatus, (state) => ({
    ...state,
    check360ReportQuery: {
      ...state.check360ReportQuery,
      error: undefined,
      loading: true
    }
  })),
  on(
    assistantSubscriptionActions.check360ReportStatusSuccess,
    (state, payload) => ({
      ...state,
      check360ReportQuery: {
        ...state.check360ReportQuery,
        error: undefined,
        loading: false,
        result: payload.result,
        queryCount: state.check360ReportQuery.queryCount + 1
      }
    })
  ),
  on(
    assistantSubscriptionActions.check360ReportStatusFailed,
    (state, payload) => ({
      ...state,
      check360ReportQuery: {
        ...state.check360ReportQuery,
        error: payload.error,
        loading: false,
        result: {
          hasActivated: false,
          hasPurchased: false,
          hasReleased: false,
          ableToUnlock: false
        },
        queryCount: state.check360ReportQuery.queryCount + 1
      }
    })
  ),
  on(assistantSubscriptionActions.resetData, () => assistantSubscriptionState),
  on(assistantSubscriptionActions.fetchUserSubscriptionChannel, (state) => ({
    ...state,
    userSubscriptionChannelsQuery: {
      ...state.userSubscriptionChannelsQuery,
      error: undefined,
      loading: true
    }
  })),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionChannelSuccess,
    (state, payload) => ({
      ...state,
      userSubscriptionChannelsQuery: {
        ...state.userSubscriptionChannelsQuery,
        error: undefined,
        loading: false,
        result: payload.result,
        queryCount: state.userSubscriptionChannelsQuery.queryCount + 1
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionChannelFailed,
    (state, payload) => ({
      ...state,
      userSubscriptionChannelsQuery: {
        ...state.userSubscriptionChannelsQuery,
        error: payload.error,
        loading: false,
        queryCount: state.userSubscriptionChannelsQuery.queryCount + 1
      }
    })
  ),
  on(assistantSubscriptionActions.fetchProductSubscriptions, (state) => ({
    ...state,
    productSubscriptionsQuery: {
      ...state.productSubscriptionsQuery,
      error: undefined,
      loading: true
    }
  })),
  on(
    assistantSubscriptionActions.fetchProductSubscriptionsSuccess,
    (state, payload) => ({
      ...state,
      productSubscriptionsQuery: {
        ...state.productSubscriptionsQuery,
        error: undefined,
        loading: false,
        result: payload.result,
        queryCount: state.productSubscriptionsQuery.queryCount + 1
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchProductSubscriptionsFailed,
    (state, payload) => ({
      ...state,
      productSubscriptionsQuery: {
        ...state.productSubscriptionsQuery,
        error: payload.error,
        loading: false,
        queryCount: state.productSubscriptionsQuery.queryCount + 1
      }
    })
  ),
  on(assistantSubscriptionActions.setModalSubscription, (state, payload) => ({
    ...state,
    isModalSubscriptionOpen: payload.isModalSubscriptionOpen
  })),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionDetailsAndUsages,
    (state) => ({
      ...state,
      loadingSubscription: true,
      userSubscriptionDetails: {
        ...state.userSubscriptionDetails,
        loading: true
      },
      userSubscriptionUsages: {
        ...state.userSubscriptionUsages,
        loading: true
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionDetailsAndUsagesSuccess,
    (state) => ({
      ...state,
      loadingSubscription: false,
      userSubscriptionDetails: {
        ...state.userSubscriptionDetails,
        loading: false
      },
      userSubscriptionUsages: {
        ...state.userSubscriptionUsages,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionDetailsAndUsagesFailed,
    (state) => ({
      ...state,
      loadingSubscription: false,
      userSubscriptionDetails: {
        ...state.userSubscriptionDetails,
        loading: false
      },
      userSubscriptionUsages: {
        ...state.userSubscriptionUsages,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionDetailsSuccess,
    (state, payload) => ({
      ...state,
      userSubscriptionDetails: {
        ...state.userSubscriptionDetails,
        data: payload.data,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionDetailsFailed,
    (state, payload) => ({
      ...state,
      userSubscriptionDetails: {
        ...state.userSubscriptionDetails,
        error: payload.error,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionUsagesSuccess,
    (state, payload) => ({
      ...state,
      userSubscriptionUsages: {
        ...state.userSubscriptionUsages,
        results: payload.result,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.fetchUserSubscriptionUsagesFailed,
    (state, payload) => ({
      ...state,
      userSubscriptionUsages: {
        ...state.userSubscriptionUsages,
        error: payload.error,
        loading: false
      }
    })
  ),
  on(
    assistantSubscriptionActions.setAvailabilityFeedback,
    (state, payload) => ({
      ...state,
      availabilityFeedback: payload.result
    })
  )
);
